"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
  t = (e = require("tiny-invariant")) && "object" == typeof e && "default" in e ? e.default : e,
  n = require("@ethersproject/hash"),
  r = require("@ethersproject/bignumber"),
  a = require("@ethersproject/contracts"),
  i = r.BigNumber.from("0xffffffffffff"),
  s = r.BigNumber.from("0xffffffffffffffffffffffffffffffffffffffff"),
  o = r.BigNumber.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"),
  p = s,
  u = i,
  y = i,
  d = o,
  l = o,
  m = o,
  c = r.BigNumber.from(0);
function f(e, t) {
  return {
    name: "Permit2",
    chainId: t,
    verifyingContract: e
  };
}
var h = [{
    name: "token",
    type: "address"
  }, {
    name: "amount",
    type: "uint160"
  }, {
    name: "expiration",
    type: "uint48"
  }, {
    name: "nonce",
    type: "uint48"
  }],
  T = {
    PermitSingle: [{
      name: "details",
      type: "PermitDetails"
    }, {
      name: "spender",
      type: "address"
    }, {
      name: "sigDeadline",
      type: "uint256"
    }],
    PermitDetails: h
  },
  v = {
    PermitBatch: [{
      name: "details",
      type: "PermitDetails[]"
    }, {
      name: "spender",
      type: "address"
    }, {
      name: "sigDeadline",
      type: "uint256"
    }],
    PermitDetails: h
  },
  g = function () {
    function e() {}
    return e.getPermitData = function (e, n, r) {
      m.gte(e.sigDeadline) || t(!1);
      var a = f(n, r);
      return function (e) {
        return !Array.isArray(e.details);
      }(e) ? (w(e.details), {
        domain: a,
        types: T,
        values: e
      }) : (e.details.forEach(w), {
        domain: a,
        types: v,
        values: e
      });
    }, e.hash = function (t, r, a) {
      var i = e.getPermitData(t, r, a);
      return n._TypedDataEncoder.hash(i.domain, i.types, i.values);
    }, e;
  }();
function w(e) {
  y.gte(e.nonce) || t(!1), p.gte(e.amount) || t(!1), u.gte(e.expiration) || t(!1);
}
function x() {
  x = function x() {
    return e;
  };
  var e = {},
    t = Object.prototype,
    n = t.hasOwnProperty,
    r = "function" == typeof Symbol ? Symbol : {},
    a = r.iterator || "@@iterator",
    i = r.asyncIterator || "@@asyncIterator",
    s = r.toStringTag || "@@toStringTag";
  function o(e, t, n) {
    return Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    o({}, "");
  } catch (e) {
    o = function o(e, t, n) {
      return e[t] = n;
    };
  }
  function p(e, t, n, r) {
    var a = Object.create((t && t.prototype instanceof d ? t : d).prototype),
      i = new k(r || []);
    return a._invoke = function (e, t, n) {
      var r = "suspendedStart";
      return function (a, i) {
        if ("executing" === r) throw new Error("Generator is already running");
        if ("completed" === r) {
          if ("throw" === a) throw i;
          return {
            value: void 0,
            done: !0
          };
        }
        for (n.method = a, n.arg = i;;) {
          var s = n.delegate;
          if (s) {
            var o = w(s, n);
            if (o) {
              if (o === y) continue;
              return o;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if ("suspendedStart" === r) throw r = "completed", n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          r = "executing";
          var p = u(e, t, n);
          if ("normal" === p.type) {
            if (r = n.done ? "completed" : "suspendedYield", p.arg === y) continue;
            return {
              value: p.arg,
              done: n.done
            };
          }
          "throw" === p.type && (r = "completed", n.method = "throw", n.arg = p.arg);
        }
      };
    }(e, n, i), a;
  }
  function u(e, t, n) {
    try {
      return {
        type: "normal",
        arg: e.call(t, n)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  e.wrap = p;
  var y = {};
  function d() {}
  function l() {}
  function m() {}
  var c = {};
  o(c, a, function () {
    return this;
  });
  var f = Object.getPrototypeOf,
    h = f && f(f(A([])));
  h && h !== t && n.call(h, a) && (c = h);
  var T = m.prototype = d.prototype = Object.create(c);
  function v(e) {
    ["next", "throw", "return"].forEach(function (t) {
      o(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function g(e, t) {
    var r;
    this._invoke = function (a, i) {
      function s() {
        return new t(function (r, s) {
          !function r(a, i, s, o) {
            var p = u(e[a], e, i);
            if ("throw" !== p.type) {
              var y = p.arg,
                d = y.value;
              return d && "object" == typeof d && n.call(d, "__await") ? t.resolve(d.__await).then(function (e) {
                r("next", e, s, o);
              }, function (e) {
                r("throw", e, s, o);
              }) : t.resolve(d).then(function (e) {
                y.value = e, s(y);
              }, function (e) {
                return r("throw", e, s, o);
              });
            }
            o(p.arg);
          }(a, i, r, s);
        });
      }
      return r = r ? r.then(s, s) : s();
    };
  }
  function w(e, t) {
    var n = e.iterator[t.method];
    if (void 0 === n) {
      if (t.delegate = null, "throw" === t.method) {
        if (e.iterator.return && (t.method = "return", t.arg = void 0, w(e, t), "throw" === t.method)) return y;
        t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
      }
      return y;
    }
    var r = u(n, e.iterator, t.arg);
    if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, y;
    var a = r.arg;
    return a ? a.done ? (t[e.resultName] = a.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, y) : a : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, y);
  }
  function b(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function P(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function k(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(b, this), this.reset(!0);
  }
  function A(e) {
    if (e) {
      var t = e[a];
      if (t) return t.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var r = -1,
          i = function t() {
            for (; ++r < e.length;) if (n.call(e, r)) return t.value = e[r], t.done = !1, t;
            return t.value = void 0, t.done = !0, t;
          };
        return i.next = i;
      }
    }
    return {
      next: E
    };
  }
  function E() {
    return {
      value: void 0,
      done: !0
    };
  }
  return l.prototype = m, o(T, "constructor", m), o(m, "constructor", l), l.displayName = o(m, s, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === l || "GeneratorFunction" === (t.displayName || t.name));
  }, e.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, o(e, s, "GeneratorFunction")), e.prototype = Object.create(T), e;
  }, e.awrap = function (e) {
    return {
      __await: e
    };
  }, v(g.prototype), o(g.prototype, i, function () {
    return this;
  }), e.AsyncIterator = g, e.async = function (t, n, r, a, i) {
    void 0 === i && (i = Promise);
    var s = new g(p(t, n, r, a), i);
    return e.isGeneratorFunction(n) ? s : s.next().then(function (e) {
      return e.done ? e.value : s.next();
    });
  }, v(T), o(T, s, "Generator"), o(T, a, function () {
    return this;
  }), o(T, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (e) {
    var t = [];
    for (var n in e) t.push(n);
    return t.reverse(), function n() {
      for (; t.length;) {
        var r = t.pop();
        if (r in e) return n.value = r, n.done = !1, n;
      }
      return n.done = !0, n;
    };
  }, e.values = A, k.prototype = {
    constructor: k,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(P), !e) for (var t in this) "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var t = this;
      function r(n, r) {
        return s.type = "throw", s.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
      }
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var i = this.tryEntries[a],
          s = i.completion;
        if ("root" === i.tryLoc) return r("end");
        if (i.tryLoc <= this.prev) {
          var o = n.call(i, "catchLoc"),
            p = n.call(i, "finallyLoc");
          if (o && p) {
            if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return r(i.finallyLoc);
          } else if (o) {
            if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
          } else {
            if (!p) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return r(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var a = this.tryEntries[r];
        if (a.tryLoc <= this.prev && n.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
          var i = a;
          break;
        }
      }
      i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
      var s = i ? i.completion : {};
      return s.type = e, s.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(s);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), P(n), y;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.tryLoc === e) {
          var r = n.completion;
          if ("throw" === r.type) {
            var a = r.arg;
            P(n);
          }
          return a;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, t, n) {
      return this.delegate = {
        iterator: A(e),
        resultName: t,
        nextLoc: n
      }, "next" === this.method && (this.arg = void 0), y;
    }
  }, e;
}
function b(e, t, n, r, a, i, s) {
  try {
    var o = e[i](s),
      p = o.value;
  } catch (e) {
    return void n(e);
  }
  o.done ? t(p) : Promise.resolve(p).then(r, a);
}
function P(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (r, a) {
      var i = e.apply(t, n);
      function s(e) {
        b(i, r, a, s, o, "next", e);
      }
      function o(e) {
        b(i, r, a, s, o, "throw", e);
      }
      s(void 0);
    });
  };
}
function k() {
  return (k = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var A = [{
    name: "token",
    type: "address"
  }, {
    name: "amount",
    type: "uint256"
  }],
  E = {
    PermitTransferFrom: [{
      name: "permitted",
      type: "TokenPermissions"
    }, {
      name: "spender",
      type: "address"
    }, {
      name: "nonce",
      type: "uint256"
    }, {
      name: "deadline",
      type: "uint256"
    }],
    TokenPermissions: A
  },
  S = {
    PermitBatchTransferFrom: [{
      name: "permitted",
      type: "TokenPermissions[]"
    }, {
      name: "spender",
      type: "address"
    }, {
      name: "nonce",
      type: "uint256"
    }, {
      name: "deadline",
      type: "uint256"
    }],
    TokenPermissions: A
  },
  D = function () {
    function e() {}
    return e.getPermitData = function (e, n, r, a) {
      m.gte(e.deadline) || t(!1), l.gte(e.nonce) || t(!1);
      var i = f(n, r);
      return function (e) {
        return !Array.isArray(e.permitted);
      }(e) ? (I(e.permitted), {
        domain: i,
        types: a ? function (e) {
          return k({
            PermitWitnessTransferFrom: [{
              name: "permitted",
              type: "TokenPermissions"
            }, {
              name: "spender",
              type: "address"
            }, {
              name: "nonce",
              type: "uint256"
            }, {
              name: "deadline",
              type: "uint256"
            }, {
              name: "witness",
              type: e.witnessTypeName
            }],
            TokenPermissions: A
          }, e.witnessType);
        }(a) : E,
        values: a ? Object.assign(e, {
          witness: a.witness
        }) : e
      }) : (e.permitted.forEach(I), {
        domain: i,
        types: a ? function (e) {
          return k({
            PermitBatchWitnessTransferFrom: [{
              name: "permitted",
              type: "TokenPermissions[]"
            }, {
              name: "spender",
              type: "address"
            }, {
              name: "nonce",
              type: "uint256"
            }, {
              name: "deadline",
              type: "uint256"
            }, {
              name: "witness",
              type: e.witnessTypeName
            }],
            TokenPermissions: A
          }, e.witnessType);
        }(a) : S,
        values: a ? Object.assign(e, {
          witness: a.witness
        }) : e
      });
    }, e.hash = function (t, r, a, i) {
      var s = e.getPermitData(t, r, a, i);
      return n._TypedDataEncoder.hash(s.domain, s.types, s.values);
    }, e;
  }();
function I(e) {
  d.gte(e.amount) || t(!1);
}
var L = [{
  inputs: [],
  name: "AllowanceExpired",
  type: "error"
}, {
  inputs: [],
  name: "ExcessiveInvalidation",
  type: "error"
}, {
  inputs: [],
  name: "InsufficientAllowance",
  type: "error"
}, {
  inputs: [],
  name: "InvalidAmount",
  type: "error"
}, {
  inputs: [],
  name: "InvalidContractSignature",
  type: "error"
}, {
  inputs: [],
  name: "InvalidNonce",
  type: "error"
}, {
  inputs: [],
  name: "InvalidSignature",
  type: "error"
}, {
  inputs: [],
  name: "InvalidSigner",
  type: "error"
}, {
  inputs: [],
  name: "LengthMismatch",
  type: "error"
}, {
  inputs: [],
  name: "NotSpender",
  type: "error"
}, {
  inputs: [],
  name: "SignatureExpired",
  type: "error"
}, {
  anonymous: !1,
  inputs: [{
    indexed: !0,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: !0,
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    indexed: !0,
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    indexed: !1,
    internalType: "uint160",
    name: "amount",
    type: "uint160"
  }, {
    indexed: !1,
    internalType: "uint48",
    name: "expiration",
    type: "uint48"
  }],
  name: "Approval",
  type: "event"
}, {
  anonymous: !1,
  inputs: [{
    indexed: !0,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: !1,
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    indexed: !1,
    internalType: "address",
    name: "spender",
    type: "address"
  }],
  name: "Lockdown",
  type: "event"
}, {
  anonymous: !1,
  inputs: [{
    indexed: !0,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: !0,
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    indexed: !0,
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    indexed: !1,
    internalType: "uint48",
    name: "newNonce",
    type: "uint48"
  }, {
    indexed: !1,
    internalType: "uint48",
    name: "oldNonce",
    type: "uint48"
  }],
  name: "NonceInvalidation",
  type: "event"
}, {
  anonymous: !1,
  inputs: [{
    indexed: !0,
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    indexed: !1,
    internalType: "uint256",
    name: "word",
    type: "uint256"
  }, {
    indexed: !1,
    internalType: "uint256",
    name: "mask",
    type: "uint256"
  }],
  name: "UnorderedNonceInvalidation",
  type: "event"
}, {
  inputs: [],
  name: "DOMAIN_SEPARATOR",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "allowance",
  outputs: [{
    internalType: "uint160",
    name: "amount",
    type: "uint160"
  }, {
    internalType: "uint48",
    name: "expiration",
    type: "uint48"
  }, {
    internalType: "uint48",
    name: "nonce",
    type: "uint48"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    internalType: "uint160",
    name: "amount",
    type: "uint160"
  }, {
    internalType: "uint48",
    name: "expiration",
    type: "uint48"
  }],
  name: "approve",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "address",
    name: "spender",
    type: "address"
  }, {
    internalType: "uint48",
    name: "newNonce",
    type: "uint48"
  }],
  name: "invalidateNonces",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "wordPos",
    type: "uint256"
  }, {
    internalType: "uint256",
    name: "mask",
    type: "uint256"
  }],
  name: "invalidateUnorderedNonces",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      internalType: "address",
      name: "token",
      type: "address"
    }, {
      internalType: "address",
      name: "spender",
      type: "address"
    }],
    internalType: "struct IAllowanceTransfer.TokenSpenderPair[]",
    name: "approvals",
    type: "tuple[]"
  }],
  name: "lockdown",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  name: "nonceBitmap",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    components: [{
      components: [{
        internalType: "address",
        name: "token",
        type: "address"
      }, {
        internalType: "uint160",
        name: "amount",
        type: "uint160"
      }, {
        internalType: "uint48",
        name: "expiration",
        type: "uint48"
      }, {
        internalType: "uint48",
        name: "nonce",
        type: "uint48"
      }],
      internalType: "struct IAllowanceTransfer.PermitDetails[]",
      name: "details",
      type: "tuple[]"
    }, {
      internalType: "address",
      name: "spender",
      type: "address"
    }, {
      internalType: "uint256",
      name: "sigDeadline",
      type: "uint256"
    }],
    internalType: "struct IAllowanceTransfer.PermitBatch",
    name: "permitBatch",
    type: "tuple"
  }, {
    internalType: "bytes",
    name: "signature",
    type: "bytes"
  }],
  name: "permit",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    components: [{
      components: [{
        internalType: "address",
        name: "token",
        type: "address"
      }, {
        internalType: "uint160",
        name: "amount",
        type: "uint160"
      }, {
        internalType: "uint48",
        name: "expiration",
        type: "uint48"
      }, {
        internalType: "uint48",
        name: "nonce",
        type: "uint48"
      }],
      internalType: "struct IAllowanceTransfer.PermitDetails",
      name: "details",
      type: "tuple"
    }, {
      internalType: "address",
      name: "spender",
      type: "address"
    }, {
      internalType: "uint256",
      name: "sigDeadline",
      type: "uint256"
    }],
    internalType: "struct IAllowanceTransfer.PermitSingle",
    name: "permitSingle",
    type: "tuple"
  }, {
    internalType: "bytes",
    name: "signature",
    type: "bytes"
  }],
  name: "permit",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      components: [{
        internalType: "address",
        name: "token",
        type: "address"
      }, {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }],
      internalType: "struct ISignatureTransfer.TokenPermissions[]",
      name: "permitted",
      type: "tuple[]"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    internalType: "struct ISignatureTransfer.PermitBatchTransferFrom",
    name: "permit",
    type: "tuple"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    components: [{
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "requestedAmount",
      type: "uint256"
    }],
    internalType: "struct ISignatureTransfer.SignatureTransferDetails[]",
    name: "transferDetails",
    type: "tuple[]"
  }, {
    internalType: "bytes",
    name: "signature",
    type: "bytes"
  }],
  name: "permitTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      components: [{
        internalType: "address",
        name: "token",
        type: "address"
      }, {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }],
      internalType: "struct ISignatureTransfer.TokenPermissions",
      name: "permitted",
      type: "tuple"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    internalType: "struct ISignatureTransfer.PermitTransferFrom",
    name: "permit",
    type: "tuple"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "requestedAmount",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "signature",
    type: "bytes"
  }],
  name: "permitTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      components: [{
        internalType: "address",
        name: "token",
        type: "address"
      }, {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }],
      internalType: "struct ISignatureTransfer.TokenPermissions",
      name: "permitted",
      type: "tuple"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    internalType: "struct ISignatureTransfer.PermitTransferFrom",
    name: "permit",
    type: "tuple"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "requestedAmount",
    type: "uint256"
  }, {
    internalType: "bytes32",
    name: "witness",
    type: "bytes32"
  }, {
    internalType: "string",
    name: "witnessTypeName",
    type: "string"
  }, {
    internalType: "string",
    name: "witnessType",
    type: "string"
  }, {
    internalType: "bytes",
    name: "signature",
    type: "bytes"
  }],
  name: "permitWitnessTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    components: [{
      components: [{
        internalType: "address",
        name: "token",
        type: "address"
      }, {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }],
      internalType: "struct ISignatureTransfer.TokenPermissions[]",
      name: "permitted",
      type: "tuple[]"
    }, {
      internalType: "uint256",
      name: "nonce",
      type: "uint256"
    }, {
      internalType: "uint256",
      name: "deadline",
      type: "uint256"
    }],
    internalType: "struct ISignatureTransfer.PermitBatchTransferFrom",
    name: "permit",
    type: "tuple"
  }, {
    internalType: "address",
    name: "owner",
    type: "address"
  }, {
    components: [{
      internalType: "address",
      name: "to",
      type: "address"
    }, {
      internalType: "uint256",
      name: "requestedAmount",
      type: "uint256"
    }],
    internalType: "struct ISignatureTransfer.SignatureTransferDetails[]",
    name: "transferDetails",
    type: "tuple[]"
  }, {
    internalType: "bytes32",
    name: "witness",
    type: "bytes32"
  }, {
    internalType: "string",
    name: "witnessTypeName",
    type: "string"
  }, {
    internalType: "string",
    name: "witnessType",
    type: "string"
  }, {
    internalType: "bytes",
    name: "signature",
    type: "bytes"
  }],
  name: "permitWitnessTransferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "token",
    type: "address"
  }, {
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint160",
    name: "amount",
    type: "uint160"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    components: [{
      internalType: "address",
      name: "token",
      type: "address"
    }, {
      internalType: "uint160",
      name: "amount",
      type: "uint160"
    }, {
      internalType: "address",
      name: "to",
      type: "address"
    }],
    internalType: "struct IAllowanceTransfer.AllowanceTransferDetails[]",
    name: "transferDetails",
    type: "tuple[]"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
exports.AllowanceProvider = function () {
  function e(e, t) {
    this.provider = e, this.permit2Address = t, this.permit2 = new a.Contract(this.permit2Address, L, this.provider);
  }
  var t = e.prototype;
  return t.getAllowanceData = function () {
    var e = P(x().mark(function e(t, n, r) {
      return x().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, this.permit2.allowance(n, t, r);
          case 2:
            return e.abrupt("return", e.sent);
          case 3:
          case "end":
            return e.stop();
        }
      }, e, this);
    }));
    return function (t, n, r) {
      return e.apply(this, arguments);
    };
  }(), t.getAllowance = function () {
    var e = P(x().mark(function e(t, n, r) {
      return x().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, this.getAllowanceData(t, n, r);
          case 2:
            return e.abrupt("return", e.sent.amount);
          case 3:
          case "end":
            return e.stop();
        }
      }, e, this);
    }));
    return function (t, n, r) {
      return e.apply(this, arguments);
    };
  }(), t.getNonce = function () {
    var e = P(x().mark(function e(t, n, r) {
      return x().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, this.getAllowanceData(t, n, r);
          case 2:
            return e.abrupt("return", e.sent.nonce);
          case 3:
          case "end":
            return e.stop();
        }
      }, e, this);
    }));
    return function (t, n, r) {
      return e.apply(this, arguments);
    };
  }(), t.getExpiration = function () {
    var e = P(x().mark(function e(t, n, r) {
      return x().wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return e.next = 2, this.getAllowanceData(t, n, r);
          case 2:
            return e.abrupt("return", e.sent.expiration);
          case 3:
          case "end":
            return e.stop();
        }
      }, e, this);
    }));
    return function (t, n, r) {
      return e.apply(this, arguments);
    };
  }(), e;
}(), exports.AllowanceTransfer = g, exports.InstantExpiration = c, exports.MaxAllowanceExpiration = u, exports.MaxAllowanceTransferAmount = p, exports.MaxOrderedNonce = y, exports.MaxSigDeadline = m, exports.MaxSignatureTransferAmount = d, exports.MaxUint160 = s, exports.MaxUint256 = o, exports.MaxUint48 = i, exports.MaxUnorderedNonce = l, exports.PERMIT2_ADDRESS = "0x000000000022D473030F116dDEE9F6B43aC78BA3", exports.SignatureTransfer = D;